export default "__VITE_ASSET__BuJiCgoY__"